import { render } from "./servicesScreen.vue?vue&type=template&id=c1807ddc&scoped=true"
import script from "./servicesScreen.vue?vue&type=script&lang=js"
export * from "./servicesScreen.vue?vue&type=script&lang=js"

import "./servicesScreen.vue?vue&type=style&index=0&id=c1807ddc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1807ddc"]])

export default __exports__